module.exports = __webpack_public_path__ + "static/media/contact-dark.b97c73da.svg";